import React, { memo } from 'react';
import I18n from '../../../I18n';
import CTAButton from '../cta_button';

// DEPRECATED - just use CTAButton directly
export default memo(function (props) {
  return (
    <CTAButton
      onPress={props.onPress}
      label={props.label || I18n.t('next')}
      style={props.style}
      disabled={props.disabled}
    />
  );
});
